export class Visible{
	init(){
		var elem = $('.features-list--risks-themes, .button-arrow, .search-form__selected-filters, .main-layout #contentArea, .main-layout .article__langs, .research-submenu__item, .article__top, .line-spacer, .articles-list--team-list .articles-list__item, .articles-list__content > *, .from-left, .from-right, .from-bottom, .features-list--icon-text .features-list__item, .features-list--inv-app .features-list__item, .features-list--risks, .team-member__contact, .team-member__nav, .articles-list--vertical-team-list, .investment-products__item, .results-list__controls');
		var self = this;

		$(window).scroll(function() {
			self.checkIfVisible(elem);
		});

		self.delay($('.features-list--icon-text .features-list__item'));
		self.delay($('.results-list .results-list__item'), 100, 100);
		self.delay($('.features-list--inv-app .features-list__item'));
		// self.delay($('.article-share__item'));
		self.delay($('.investment-products__item'));
		self.delayChildrenRandom($('.articles-list--team-list'));
		self.delayChildren($('.news-list'));

		$(document).ready(function() {
			self.checkIfVisible(elem);
		})
	}
	checkIfVisible(elem){
		elem.each(function() {
			var $this = $(this),
				elemVisible = $this.visible(true, 'vertical');

			if(elemVisible){
				$this.addClass('on-screen', elemVisible);
				setTimeout(function() {
					$this.addClass('triggered');
				}, 500);
			}
		});
	}
	delay(elem, delay = 300, multiplier = 150){
		elem.each(function(index) {
			$(this).css('transition-delay', (delay+(multiplier*index) + 'ms'));
		});
	}
	delayChildren(elem, delay = 50, multiplier = 150){
		elem.each(function() {
			let children = $(this).children();
			children.each(function(index) {
				$(this).css('transition-delay', (delay+(multiplier*index) + 'ms'));
			});
		});
	}
	delayChildrenRandom(elem, delay = 50, multiplier = 150){
		let children = elem.find('.articles-list__item');
		children.each(function(index) {
			let multiplier = Math.random() * 35;
			$(this).css('transition-delay', (delay+(multiplier*index) + 'ms'));
		});
	}
}